<ion-header>
    <ion-toolbar>
        <ion-title>{{'View Policy' | translate}}</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="modalDissmissed()" fill="clear" color="dark">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    @if(organisation){
              <ion-item color="light">
                 <ion-label class="policy-name">{{'Organisation Name' | translate}}:</ion-label> 
                 <ion-text slot="end">{{organisation?.organisationName}}</ion-text>
              </ion-item>

              @if(tournament?.policy){
                <ion-item>
                    <ion-label class="policy-name">{{'Policy Name' | translate}}:</ion-label> 
                    <ion-text slot="end">{{tournament?.policy?.name}}</ion-text>
                </ion-item>
                <ion-item color="light">
                    <ion-label class="policy-name">{{'Timeout Details' | translate}}</ion-label> 
                </ion-item>
                <ion-item class="policy-data">
                    <ion-label class="policy-name">{{'Format' | translate}}:</ion-label> 
                    <ion-text slot="end">{{tournament?.policy?.configuration?.timeouts?.timeFormat}}</ion-text>
                </ion-item>
                 <ion-item class="policy-data">
                    <ion-label class="policy-name">{{'Duration' | translate}}:</ion-label> 
                    <ion-text slot="end">{{tournament?.policy?.configuration?.timeouts?.timeoutDuration}}</ion-text>
                </ion-item>
                <ion-item class="policy-data">
                    <ion-label class="policy-name">{{'Per Match' | translate}}:</ion-label> 
                    <ion-text slot="end">{{tournament?.policy?.configuration?.timeouts?.timeoutPerMatch}}</ion-text>
                </ion-item>
                <ion-item class="policy-data">
                    <ion-label class="policy-name">{{'Per Set' | translate}}:</ion-label> 
                    <ion-text slot="end">{{tournament?.policy?.configuration?.timeouts?.timeoutPerSet}}</ion-text>
                </ion-item>
            } @else {
                <app-empty-page text="{{'No policy.' | translate}}" iconName="receipt-outline"></app-empty-page>
            }
    } @else {
        <app-empty-page text="{{'No Organization' | translate}}." iconName="receipt-outline"></app-empty-page>
    }
</ion-content>